export default __webpack_public_path__ + "34d9ec3745f3b2aab189700150f84c17.svg";